import { useContext, useEffect, useState } from 'react';

import { timeoutFetchSentryGuard } from 'Fetch';

import { ConfigContext } from 'Context/config';

import { fetchLandingPage } from 'Utilities/wordpressPages';

const useFetchWordpressData = (url) => {
  const {
    configActions: { update },
    configState: { landingPageData },
  } = useContext(ConfigContext);

  const trackerWordpressData = landingPageData?.content;

  const [acf, setAcf] = useState(trackerWordpressData);
  const [apiError, setApiError] = useState(false);

  useEffect(() => {
    if (!acf) {
      fetchLandingPage(url).then((data) => {
        setAcf(data.content);
      }).catch((err) => {
        setApiError(err);
        timeoutFetchSentryGuard(err, () => window?.Sentry?.captureException(new Error(err), {
          level: 'warning',
          tags: {
            fetch: `Valuation tracker landing page ${url}`,
          },
        }));
      });
    }
    return () => update({ landingPageData: null });
  }, [acf, url, update]);

  return {
    acf, apiError,
  };
};

export default useFetchWordpressData;
